/**
 * Composable filter bar used by list pages. Consumers drop in any number
 * of child filter controls (selects, date pickers, toggles) and FilterBar
 * gives them a consistent layout with a "Clear filters" action.
 */

import React from 'react';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';

export interface FilterBarProps {
  children: React.ReactNode;
  activeCount?: number;
  onClear?: () => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({ children, activeCount = 0, onClear }) => {
  return (
    <Column spacing="small" tag="section" aria-label="Filters">
      <Row alignmentVertical="center" spacing="medium" wrap="down">
        {children}
        {onClear && (
          <Button type="tertiary" onClick={onClear} disabled={activeCount === 0}>
            Clear filters
          </Button>
        )}
      </Row>
      {activeCount > 0 && (
        <Text type="b200" color="secondary">
          {activeCount} filter{activeCount === 1 ? '' : 's'} applied
        </Text>
      )}
    </Column>
  );
};
